import { render } from "./AddVpnUser.vue?vue&type=template&id=8acc99a0&scoped=true"
import script from "./AddVpnUser.vue?vue&type=script&lang=js"
export * from "./AddVpnUser.vue?vue&type=script&lang=js"

import "./AddVpnUser.vue?vue&type=style&index=0&id=8acc99a0&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8acc99a0"]])

export default __exports__